import InputBase,
{ InputBaseProps }                  from "@mui/material/InputBase";
import ButtonBase                   from "@mui/material/ButtonBase";
import { GridRenderEditCellParams } from "@mui/x-data-grid";
import { DatePicker }               from "@mui/x-date-pickers";

const GridDatePicker = (params: GridRenderEditCellParams) => {
    const now = new Date();
    return (
        <DatePicker
            views={['year', 'month']}
            label=""
            minDate={new Date('2011-01-01')}
            maxDate={new Date(now.getFullYear(), now.getMonth() - 1, 28)}
            value={params.value}
            onAccept={(date: any) => {
                if (date && params.field === 'date_of_birth') {
                    (date as Date).setDate(15);
                    let rowModel = params.api.getEditRowsModel();
                    rowModel[params.id][params.field].value = date;
                    params.api.setEditRowsModel(rowModel);
                }
                params.api.setCellFocus(params.id, 'parent_email')
            }}
            onChange={()=>{}}
            renderInput={({ inputRef, inputProps, InputProps }: any)  => (
                <>
                    <InputBase ref={inputRef} {...(inputProps as InputBaseProps)}
                        readOnly
                        sx={{ ml: 1, pl: 1, typography: 'body2' }}
                    />
                    <ButtonBase disableRipple>
                        {InputProps?.endAdornment}
                    </ButtonBase>
                </>
            )}
        />
    );
};

export default GridDatePicker;